import parse from "html-react-parser"
import { updateCDNUrls } from "aldoo-ra/Blog/Editor"

const HCCategoryNote = ({ note }) => {
  if (!note || !note.content) return null

  const parsedContent = parse(updateCDNUrls(note.content))
  const renderStyle = note.renderas || "bottom_direct"
  const [, style] = renderStyle.split("_")

  if (style === "bubble") {
    return (
      <div className="text-text bg-warning_bg rounded-[30px] py-5 pl-5 pr-[30px] mb-8">
        {parsedContent}
      </div>
    )
  }

  return <div className="my-4">{parsedContent}</div>
}

export default HCCategoryNote
